import type { useKeyboardHandler as useNativeKeyboardHandler } from "react-native-keyboard-controller";

export { KeyboardAvoidingView } from "react-native";

export function useKeyboardState() {
  return { isVisible: false } as const;
}

export const useKeyboardHandler: typeof useNativeKeyboardHandler = () => {};
